import apiClient from "../config/apiClient";
import { API_ENDPOINTS } from "../config/endpoints";

export const updateCateringUnpaidOrder = async (orderId, orderData) => {
  try {
    const response = await apiClient.post(
      `${API_ENDPOINTS.UPDATE_CATERING_UNPAID_ORDER}/${orderId}`,
      orderData
    );
    return response;
  } catch (error) {
    console.error("Error updating catering unpaid order:", error);
    throw error;
  }
};

























